import React, {useState} from 'react';
import Proptypes from 'prop-types';
import styled from 'styled-components';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import {loadingIndicatorTypes} from '../../../util/uiconstants';
import {labels} from '../../../util/utils';

function GrayFadeProgressBar(props) {
	const {children, label, customLoader} = props;
	const [isSaving, setIsSaving] = useState(false);

	const loader = customLoader ? (
		customLoader
	) : (
		<LoadingIndicator label={label} view="blockView" styleName={'gray-fade-progress-bar'} show={isSaving} />
	);
	return (
		<StyledGrayFadeProgressBar className={'StyledGrayFadeProgressBar'}>
			{isSaving && loader}
			<section className={`children-body ${isSaving ? 'gray-fade' : ''}`}>{children(setIsSaving)}</section>
		</StyledGrayFadeProgressBar>
	);
}

export default GrayFadeProgressBar;

const StyledGrayFadeProgressBar = styled.section`
	position: relative;
	width: 100%;
	.gray-fade-progress-bar {
		width: 90%;
		position: absolute;
		top: 30%;
		left: 5%;
		.motif-progress-bar-wrapper {
			span {
				font-size: var(--px-15_5) !important;
			}
			.motif-progress-bar {
				height: var(--px-5) !important;
				.motif-progress {
					width: 40%;
					background-color: var(--green-300);
					height: var(--px-5);
				}
			}
		}
	}
	.gray-fade {
		opacity: 0.6;
		pointer-events: none;
	}
`;

GrayFadeProgressBar.proptypes = {
	children: Proptypes.func.isRequired,
	label: Proptypes.string,
	customLoader: Proptypes.element
};

GrayFadeProgressBar.defaultProps = {
	label: labels.saving
};
